import { styled } from 'styled-components'

import { ButtonLink } from '@/buyer-portal/components/ButtonLink'

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
`

export const StyledButtonLink = styled(ButtonLink)`
  white-space: nowrap;
`
